'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$18() {
  this.btf = null;
  this.btg = false;
}
export { $c_Lpresto_RegisterPageView$$anon$18 as $c_Lpresto_RegisterPageView$$anon$18 };
$p = $c_Lpresto_RegisterPageView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$18;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$18() {
}
export { $h_Lpresto_RegisterPageView$$anon$18 as $h_Lpresto_RegisterPageView$$anon$18 };
$h_Lpresto_RegisterPageView$$anon$18.prototype = $p;
$p.P = (function() {
  if ((!this.btg)) {
    this.btf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.btg = true;
  }
  return this.btf;
});
var $d_Lpresto_RegisterPageView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$18, "presto.RegisterPageView$$anon$18", ({
  Qm: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$18 as $d_Lpresto_RegisterPageView$$anon$18 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$18.js.map
